<template>
  <div class="fixed inset-0 z-50 pointer-events-none">
    <div class="flex flex-col items-end justify-start space-y-4 p-4">
      <Notification
        v-for="notification in notificationStore.notifications"
        :key="notification.id"
        :notification="notification"
        @close="notificationStore.removeNotification(notification.id)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useNotificationStore } from '@/store/notifications';
import Notification from './Notification.vue';

const notificationStore = useNotificationStore();
</script>
